// removed by extract-text-webpack-plugin
module.exports = {"mainFlightsWrap":"qempo_Flights_mainFlightsWrap-4vSjdRj"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/flights/components/Flights.scss
// module id = 1716
// module chunks = 0